<template>
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M20.5978 4.71569C21.5447 4.96794 22.2898 5.71693 22.5421 6.67159C23 8.39853 22.9961 11.9999 22.9961 11.9999C22.9961 11.9999 22.9961 15.6012 22.5382 17.3281C22.2859 18.2789 21.5408 19.0279 20.5939 19.284C18.8786 19.7459 11.9981 19.7459 11.9981 19.7459C11.9981 19.7459 5.11748 19.7459 3.40219 19.284C2.45528 19.0318 1.71018 18.2828 1.45793 17.3281C1 15.6012 1 11.9999 1 11.9999C1 11.9999 1 8.39853 1.46181 6.66771C1.71406 5.71693 2.45916 4.96794 3.40607 4.71181C5.12136 4.25 12.0019 4.25 12.0019 4.25C12.0019 4.25 18.8786 4.25 20.5978 4.71569ZM9.75 8.72852V15.2715L15.5013 12L9.75 8.72852Z"
            fill="black"
        />
    </svg>
</template>
